"use strict";


/**
 * @type Controller
 * @name RundownDialogCtrl
 * @packageName rundown_dialog_ctrl.js
 *
 * @description
 *
 * The `RundownDialogCtrl` interaction delete mdDialog for rundown
 *
 */
class changePasswordDialog {


    constructor($scope, $mdDialog, $http, $mdToast) {

        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;

        this.$http = $http;

        this.$scope = $scope;

        $scope.isValid = false;
        $scope.oldPassIncorrect = false;

        $scope.sendButton = () => {
            this.sendButton();
        };

        $scope.cancelButton = () => {
            this.cancelButton();
        };

        $scope.checkValid = () => {
            this.checkValid();
        };

    }

    checkValid() {
        if (this.$scope.password_old !== undefined && this.$scope.password_new1 !== undefined) {
            this.$scope.passwordSame = false;
            if (this.$scope.password_new1.length >= 6) {
                this.$scope.newPassTooShort = false;
                if (this.$scope.password_new1 == this.$scope.password_new2) {
                    this.$scope.newPassDontMatch = false;
                    this.$scope.isValid = true;
                } else {
                    this.$scope.isValid = false;
                    this.$scope.newPassDontMatch = true;
                }
            } else {
                this.$scope.newPassTooShort = true;
                this.$scope.isValid = false;
            }
        }
    }

    cancelButton() {
        this.$mdDialog.cancel();
    }


    sendButton() {
        var passresult = {
            'old_password': this.$scope.password_old,
            'new_password': this.$scope.password_new1
        };

        this.$http.post('user/changepassword', passresult)
            .then((data, status, headers, config) => {
                if (status == 202) {
                    this.$scope.passwordSame = true;
                } else {

                    this.$mdDialog.hide();
                    this.$mdToast.show({
                        templateUrl: '/partial/app.partials.toasts.object_saved?object=password',
                        hideDelay: 6000,
                        position: ('top right')
                    });
                }
            }, (data, status, headers, config) => {
                this.$scope.passwordIncorrect = true;
            });
    }
}


/*
 * Inject dependicies
 */
changePasswordDialog.$inject = ['$scope', '$mdDialog', '$http', '$mdToast'];


/*
 * Browsify connection: execute controller
 */
module.exports = changePasswordDialog;
